import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";

const Checkout = () => {
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
  const [currency, setCurrency] = useState(options.currency || "USD");
  const [amount, setAmount] = useState("1.00");
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const onCurrencyChange = ({ target: { value } }) => {
    setCurrency(value);
    dispatch({
      type: "resetOptions",
      value: {
        ...options,
        currency: value,
      },
    });
  };

  const onCreateOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [{
        amount: { value: amount },
      }],
    });
  };

  const onApproveOrder = (data, actions) => {
    return actions.order.capture().then((details) => {
      alert(`Transaction completed by ${details.payer.name.given_name}`);
    });
  };

  return (
    <div className="flex flex-col items-center p-6 bg-gray-800 rounded-lg shadow-lg max-w-md mx-auto w-full border border-gray-700">
      <h2 className="text-2xl font-bold text-white mb-6">Pay with PayPal</h2>
      <button
            onClick={toggleDarkMode}
            className={`px-4 py-2 rounded-lg ${darkMode ? "bg-indigo-600 text-white" : "bg-gray-200 text-gray-800"}`}
          >
            {darkMode ? "☀️ Light Mode" : "🌙 Dark Mode"}
          </button>
      <div className="w-full mb-4">
        <label className="block text-gray-300 mb-2">Amount</label>
        <input
          type="number"
          min="0.01"
          step="0.01"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="w-full mb-6">
        <label className="block text-gray-300 mb-2">Currency</label>
        <select
          value={currency}
          onChange={onCurrencyChange}
          className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:ring-2 focus:ring-blue-500"
        >
          <option value="USD">USD ($)</option>
          <option value="EUR">EUR (€)</option>
          <option value="GBP">GBP (£)</option>
          <option value="AUD">AUD (A$)</option>
          <option value="CAD">CAD (C$)</option>
        </select>
      </div>

      {isPending ? (
        <div className="w-full py-8 flex justify-center">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="w-full">
          <PayPalButtons
            style={{ 
              layout: "vertical",
              color: "gold",
              shape: "rect",
              label: "pay",
              height: 40
            }}
            createOrder={onCreateOrder}
            onApprove={onApproveOrder}
          />
        </div>
      )}
    </div>
  );
};

const Paypal = () => {
  const initialOptions = {
    "client-id": process.env.PAYPAL_CLIENT_ID,
    currency: "USD",
    intent: "capture",
  };

  return (
    <PayPalScriptProvider options={initialOptions}>
      <div className="flex items-center justify-center min-h-screen bg-gray-900 p-4">
        <Checkout />
      </div>
    </PayPalScriptProvider>
  );
};

export default Paypal;